import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { chatsApi } from "@/lib/humhub-api/chats";
import { queryInvalidationHelpers } from "@/lib/queryInvalidationHelpers";

interface CreateChatRequest {
  title: string;
  message: string;
  recipient: string[];
}

export const useCreateChatRoom = () => {
  const queryClient = useQueryClient();

  // React Queryのミューテーションでチャット作成処理
  const mutation = useMutation({
    mutationFn: async (data: CreateChatRequest) => {
      return chatsApi.createChatRoom(data.title, data.message, data.recipient);
    },
    onSuccess: (_response) => {
      // ヘルパー関数を使用してチャット関連クエリを無効化
      queryInvalidationHelpers.invalidateChatQueries(queryClient);
    },
    onError: (error) => {
      console.error("Error creating chat:", error);
    },
  });

  const createChat = useCallback(
    async (data: CreateChatRequest) => {
      return mutation.mutateAsync(data);
    },
    [mutation],
  );

  return {
    createChat,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    success: mutation.isSuccess,
    chatId: mutation.data?.id || null,
  };
};
